module.exports = __webpack_public_path__ + "static/media/global.511a6aad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/global.png
// module id = 125
// module chunks = 0